var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoveCamera2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square",
    strokeWidth: 2,
    fill: "none",
    stroke: "#212121",
    className: "love-camera-2_svg__nc-icon-wrapper",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 22H3a2 2 0 01-2-2V7a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2v13a2 2 0 01-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2 9.812a2.7 2.7 0 00-4.2.428 2.7 2.7 0 00-4.2-.428 2.8 2.8 0 000 3.919L12 18l4.2-4.269a2.8 2.8 0 000-3.919z"
  }))));
}

export default SvgLoveCamera2;